import React from 'react';
import { Link } from 'react-router-dom';
import Icon from './Icon';

/**
 * Reusable federation card.
 */
const FederationCard = ({ name, territory, description, circles, members, type, icon, image, link = '/federazione' }) => {
  if (type === 'regionale') {
    return (
      <Link to={link} className="card region-card animate-on-scroll fade-up" style={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center', 
        padding: 'var(--space-10)',
        textAlign: 'center',
        background: 'var(--color-surface)',
        borderRadius: 'var(--radius-2xl)',
        border: '1px solid var(--color-border-subtle)',
        transition: 'all var(--transition-base)',
        textDecoration: 'none',
        height: '100%'
      }}>
        <div className="region-card__image-container mb-6" style={{ 
          width: '160px', 
          height: '160px', 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center',
          position: 'relative'
        }}>
          {image && (
            <img 
              src={image} 
              alt={territory} 
              style={{ 
                width: '100%', 
                height: '100%', 
                objectFit: 'contain',
                mixBlendMode: 'multiply', // Makes white background appear transparent if parent is white/light
                filter: 'drop-shadow(0 10px 20px rgba(0,0,0,0.05))'
              }} 
            />
          )}
        </div>
        <h3 className="h4 mb-1" style={{ color: 'var(--color-text)', fontWeight: 800 }}>{territory}</h3>
      </Link>
    );
  }

  return (
    <Link to={link} className="card federation-card animate-on-scroll fade-up">
      <div className="flex justify-between items-start mb-4">
        <span className="badge badge--outline text-tiny">
          Provinciale
        </span>
        {icon && (
          <div className="federation-card__visual-wrapper" style={{ 
            width: '48px', 
            height: '48px', 
            borderRadius: 'var(--radius-lg)', 
            background: 'var(--color-surface-subtle)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'var(--color-text-secondary)',
            overflow: 'hidden'
          }}>
            <Icon name={icon} size={24} />
          </div>
        )}
      </div>
      <h4 className="federation-card__name">{name}</h4>
      <div className="federation-card__territory">{territory}</div>
      {description && (
        <p className="federation-card__desc line-clamp-2">{description}</p>
      )}
      <div className="federation-card__meta">
        {circles && <span><Icon name="MapPin" size={14} style={{ marginRight: 4 }} /> {circles} circoli</span>}
        {members && <span><Icon name="Users" size={14} style={{ marginRight: 4 }} /> {members} iscritti</span>}
      </div>
    </Link>
  );
};

export default FederationCard;
